import Vue from 'vue'
import md5 from 'md5'

import store from '@store'
import router from '@router'
import axios from './axios'
import FormDialog from './formDialog'

function GetTimestamp() {
  return Math.floor(new Date().getTime() / 1000)
}

function GetSign(obj, secKey) {
  var params = Object.keys(obj).sort().map(x => ({ key: x, val: obj[x] }))
    .filter(x => x.key != 'sign' && (x.val === 0 || x.val === false || x.val))
    .map(x => `${x.key}=${x.val}`)
    .join('&')
  return md5(secKey + params + secKey).toUpperCase()
}

const AppConfig = window.AppConfig

const CacheDict = new Map()

// https://cn.vuejs.org/v2/guide/plugins.html
// http://www.axios-js.com/zh-cn/docs/#请求配置
Vue.use({
  install: function(Vue/*, options*/) {
    Vue.prototype.$httpPostFile = function(url, file) {
      const config = {
        baseURL: AppConfig.url,
        timeout: AppConfig.timeout,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }

      const { secKey = AppConfig.secKey, token, userInfo } = store.state

      var data = {}
      data.token = token
      const timeStamp = GetTimestamp()
      data.timeStamp = timeStamp
      const sign = GetSign(data, secKey)
      var fd = new FormData()
      fd.append('token', token)
      fd.append('timeStamp', timeStamp)
      fd.append('sign', sign)
      fd.append('file', file)

      return axios.post(url, fd, config)
    },

    Vue.prototype.$httpPostFile2 = function(url, data, file) {
      const config = {
        baseURL: AppConfig.url,
        timeout: AppConfig.timeout,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }

      const { secKey = AppConfig.secKey, token, userInfo } = store.state

      data.token = token
      data.timeStamp = GetTimestamp()
      data.sign = GetSign(data, secKey)

      var fd = new FormData()
      for (const key in data) {
        fd.append(key, data[key])
      }

      for (const key in file) {
        const val = file[key]
        if (val) {
          fd.append(key, val)
        }
      }

      return axios.post(url, fd, config)
    },

    Vue.prototype.$httpPost = function(url, data = {}) {
      const config = {
        baseURL: AppConfig.url,
        timeout: AppConfig.timeout
      }

      const { secKey = AppConfig.secKey, token } = store.state

      data.token = token
      data.timeStamp = GetTimestamp()
      data.sign = GetSign(data, secKey)

      return axios.post(url, data, config).then(res => {
        if (res.returnCode == '00002') {
          FormDialog.close()

          this.$alert('当前账号被踢出, 即将返回登陆页面', '注意', {
            confirmButtonText: '确定',
            callback: action => {
              router.replace({ name: 'Login' })
            }
          })

          throw res
        } else {
          return res
        }
      })
    },

    Vue.prototype.$httpPostCache = function(url, data, cacheSec = 1) {
      const cacheKey = data ? url + '?' + Object.keys(data).filter(x => data[x]).map(x => `${x}=${data[x]}`).join('&') : url
      if (CacheDict.has(cacheKey)) {
        return CacheDict.get(cacheKey)
      }
      const promise = this.$httpPost(url, data)
      CacheDict.set(cacheKey, promise)
      setTimeout(() => {
        CacheDict.delete(cacheKey)
      }, cacheSec * 1000)
      return promise
    },

    Vue.prototype.$buildDownloadUrl = function(url, data = {}) {
      const { secKey = AppConfig.secKey, token } = store.state

      data.token = token
      data.timeStamp = GetTimestamp()
      data.sign = GetSign(data, secKey)

      return AppConfig.downloadUrl + url + '?' + Object.keys(data).filter(x => data[x] === 0 || data[x] === false || data[x]).map(x => `${x}=${data[x]}`).join('&')
    },

    Vue.prototype.$ask = function(msg) {
      return this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => true).catch(() => false)
    }
  }
})
